<template>
  <v-row>
    <v-col cols="12" class="pt-0 pb-0">
      <h4>{{ $t("agenda.lblMOMElectronicSignature") }}</h4>
    </v-col>
    <v-col cols="11" sm="11">
      <v-tooltip bottom :disabled="isWansignControlNumber">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            color="primaryDark"
            class="mr-2"
            @click="onStartClick"
            :disabled="isWansignControlNumber"
          >
            {{ $t("Start") }}
          </a-btn>
        </template>
        <span>{{ $t("agenda.lblMOMElectronicSignature") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            color="primaryDark"
            class="mr-2"
            @click="onCheckStatus"
          >
            {{ $t("agenda.lblCheckStatus") }}
          </a-btn>
        </template>
        <span>{{ $t("agenda.lblCheckSignatureStatus") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            color="primaryDark"
            class="mr-2"
            :loading="isDownLoading"
            @click="onDownloadSignedDocument"
            :disabled="isDocumentSignedAll"
          >
            {{ $t("agenda.lblDownloadSignedMOM") }}
            <template v-slot:loader>
              <span>{{ $t("agenda.lblDownloading") }} ...</span>
            </template>
          </a-btn>
        </template>
        <span>{{ $t("agenda.lblDownloadSignedMOMDocument") }}</span>
      </v-tooltip>
    </v-col>
    <v-col cols="1" sm="1" md="1" class="justify-end d-flex align-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            color="primaryDark"
            :width="!isWansignControlNumber ? 32 : 24"
            :min-width="!isWansignControlNumber ? 32 : 24"
            :style="
              !isWansignControlNumber
                ? 'background-color: transparent !important;'
                : ''
            "
            x-small
            @click="resetSignedDocument"
            :disabled="!isWansignControlNumber"
          >
            <v-icon :size="!isWansignControlNumber ? 20 : 16" color="#fff">
              mdi-delete</v-icon
            >
          </a-btn>
        </template>
        <span v-html="$t('agenda.tipCancelMOMProcess')"></span>
      </v-tooltip>
    </v-col>
    <v-col v-if="isNoteDisplay" cols="12" sm="12">
      <span>{{ $t("agenda.noteMOMeSignature") }}</span>
    </v-col>
    <a-dialog
      v-if="showUploadDialog && momESignatureManagement"
      v-model="showUploadDialog"
      width="800px"
      max-width="80vw"
      persistent
      scrollable
    >
      <v-card>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1">
            <span> {{ $t("poll.lblFileUpload") }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="closeStart()" />
          </v-toolbar>
        </v-banner>
        <v-card-text style="color: black">
          <h4 class="mb-2">1. {{ $t("agenda.lblUploadeSignedDocument") }}</h4>
          <upload-file
            :files="uploadingFiles"
            :icons="fileIcons"
            @add-files="addUploadingFiles"
            @remove-file="removeUploadingFile"
            :accept="file_accept"
            :multiple="false"
            :maxsize="maxsize"
          ></upload-file>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-tooltip bottom v-if="momESignatureManagement">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mr-2"
                color="primaryDark"
                v-bind="attrs"
                v-on="on"
                :disabled="!uploadingFiles.length || errorCount > 0"
                v-if="momESignatureManagement"
                @click="onUploadDocument"
                ><span>{{ $t("documents.upload") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("documents.upload") }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn color="secondary" @click="close()" v-bind="attrs" v-on="on"
                ><span>{{ $t("btnCancel") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("btnCancel") }} </span>
          </v-tooltip>
        </v-card-actions>
        <Loader :loading="isUploading" :message="loaderText"></Loader>
      </v-card>
    </a-dialog>
    <add-signer-dialog
      v-if="showSignerDialog && momESignatureManagement"
      v-model="showSignerDialog"
      :meetingId="meetingId"
      :attendeesList="attendeesList"
      :files="uploadingFiles"
      :meetingName="meetingName"
      @send="onSignerNext"
      @back="onBack"
    ></add-signer-dialog>
    <check-signer-status
      v-if="showCheckStatusDialog"
      v-model="showCheckStatusDialog"
      :meetingId="meetingId"
      :signingInfo="signingInfo"
    ></check-signer-status>
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    >
    </message-sheet>
    <Loader :loading="isLoaderloading" :message="loaderText"></Loader>
    <confirm-dialog ref="confirmDelete" />
  </v-row>
</template>

<script>
import UploadFile from "../../documents/UploadFile.vue";
import { fileIcons } from "../../../utils/constant";
import { formatBytes } from "../../../utils/util";
import { mapActions, mapState } from "vuex";
import Loader from "../../Loader.vue";
import AddSignerDialog from "./AddSignerDialog.vue";
import AddObserverStep from "./AddObserverStep.vue";
import CheckSignerStatus from "./CheckSignerStatus.vue";
import MessageSheet from "../../MessageSheet.vue";
import ConfirmDialog from "../../ConfirmDialog.vue";
import SignalRMixin from "../../../mixin/SignalRMixin";

export default {
  name: "MOMSignature",
  mixins: [SignalRMixin],
  components: {
    UploadFile,
    Loader,
    AddSignerDialog,
    CheckSignerStatus,
    MessageSheet,
    ConfirmDialog,
    AddObserverStep
  },
  props: {
    meetingId: String,
    meetingTypeId: String,
    attendeesList: Array,
    meetingObject: Object,
  },
  data() {
    return {
      displayMessage: false,
      messageType: "",
      message: "",
      isUploading: false,
      isDownLoading: false,
      showCheckStatusDialog: false,
      showSignerDialog: false,
      isLoaderloading: false,
      showUploadDialog: false,
      fileIcons,
      uploadingFiles: [],
      file_accept: ["application/pdf"],
      signingInfo: [],
      maxsize: 20000000,
      isAllSignerSigned: false,
      
    };
  },
  async mounted() {
    const target = `wansign_status_${this.meetingId}`;
    await this.signalRInit(target);
  },
  computed: {
    loaderText() {
      return this.$t("LoaderText");
    },
    ...mapState({
      momSignatureData: (state) => state.meeting.momSignatureData,
    }),
    momESignatureManagement() {
      if (this.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingTypeId,
          "MomESignatureManagement"
        );
      }
      return false;
    },
    meetingName() {
      if (this.meetingObject && this.meetingObject.meetingName) {
        return this.meetingObject.meetingName;
      }
      return "";
    },
    documentName() {
      if (this.momSignatureData && this.momSignatureData.document_name) {
        return this.momSignatureData.document_name;
      } else if (
        this.meetingObject &&
        this.meetingObject.mom_signature_data &&
        this.meetingObject.mom_signature_data.document_name
      ) {
        return this.meetingObject.mom_signature_data.document_name;
      } else {
        return null;
      }
    },
    isDocumentSignedAll() {
      return !(
        this.isAllSignerSigned ||
        (this.meetingObject && this.meetingObject.is_document_signed_all)
      );
    },
    isWansignControlNumber() {
      if (
        this.momSignatureData &&
        this.momSignatureData.wansign_control_number
      ) {
        return true;
      } else if (
        this.meetingObject &&
        this.meetingObject.mom_signature_data &&
        this.meetingObject.mom_signature_data.wansign_control_number
      ) {
        return true;
      }
      return false;
    },
    errorCount() {
      let count = 0;
      for (const item of this.uploadingFiles) {
        if (this.checkStatus(item).status == false) {
          count++;
        }
      }
      return count;
    },
    isNoteDisplay() {
      return this.isDocumentSignedAll && this.isWansignControlNumber;
    },
  },
  methods: {
    ...mapActions({
      setMomSignatureFile: "agenda/setMomSignatureFile",
      momSignatureDocumentDownload: "agenda/momSignatureDocumentDownload",
      momSignatureDocumentStatus: "agenda/momSignatureDocumentStatus",
      setWanSignEmailStatus: "meeting/setWanSignEmailStatus",
      momWansignDocumentReset: "meeting/momWansignDocumentReset",
      getObservers: "agenda/getObservers",
    }),
    addUploadingFiles,
    removeUploadingFile,
    onUploadDocument,
    onStartClick,
    close,
    closeStart,
    onCheckStatus,
    onDownloadSignedDocument,
    resetSignedDocument,
    downloadDocument,
    onEmailSend,
    onSignerNext,
    showMessageSheet,
    onBack,
    signalRInit,
    checkStatus(file) {
      const maxSize = this.maxsize;
      let filesWithStatus = {};
      if (!this.file_accept.includes(file.type)) {
        filesWithStatus = {
          filename: file.name,
          status: false,
          message: this.$t("fileErrorMsg", { filename: file.fileName }),
        };
      } else if (file.size > maxSize) {
        filesWithStatus = {
          filename: file.name,
          status: false,
          message: this.$t("fileSizeErrorMsg", {
            maxsize: formatBytes(maxSize),
          }),
        };
      } else {
        filesWithStatus = {
          filename: file.name,
          status: true,
          message: "Success",
        };
      }
      return filesWithStatus;
    },
  },
};

async function signalRInit(target) {
  try {
    this.signalConnection.on(target, async (res) => {
      this.isAllSignerSigned = res.is_document_signed_all;
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {}
}

async function onDownloadSignedDocument() {
  this.isDownLoading = true;
  try {
    const params = {
      meetingId: this.meetingId,
      filename: this.documentName,
    };
    const res = await this.momSignatureDocumentDownload(params);
    var blob = new Blob([res.data], { type: "application/pdf" });
    var url = window.URL.createObjectURL(blob);
    this.downloadDocument(url, this.documentName);
    this.isDownLoading = false;
  } catch (error) {
    this.isDownLoading = false;
  }
}

function downloadDocument(url, name) {
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  a.href = url;
  a.download = name;
  a.setAttribute("download", name);
  a.click();
  window.URL.revokeObjectURL(url);
}
async function resetSignedDocument() {
  try {
    if (
      await this.$refs.confirmDelete.open(
        this.$t("dashboard.lblConfirmReset"),
        this.$t("msgConfirmReset")
      )
    ) {
      this.isLoaderloading = true;
      const result = await this.momWansignDocumentReset(this.meetingId);
      if (result.status) {
        this.setWanSignEmailStatus(null);
        this.meetingObject.mom_signature_data = null;
        this.isAllSignerSigned = false;
        this.meetingObject.is_document_signed_all = false;
        this.showMessageSheet(this.$t("msgResetsuccess"), "success");
      }
      this.isLoaderloading = false;
    }
  } catch (error) {
    this.isLoaderloading = false;
  }
}

async function onCheckStatus() {
  try {
    this.isLoaderloading = true;
    await this.getObservers(this.meetingTypeId);
    const result = await this.momSignatureDocumentStatus(this.meetingId);
    const responseData = result.data;
    const { signing_info } = responseData;
    this.signingInfo = signing_info;
    this.isLoaderloading = false;
    this.showCheckStatusDialog = true;
  } catch (error) {
    this.isLoaderloading = false;
  }
}

async function addUploadingFiles(files) {
  files = Array.from(files);
  this.uploadingFiles = [];
  this.$nextTick(() => {
    this.uploadingFiles.push(...files);
  });
}

function removeUploadingFile(index) {
  this.uploadingFiles.splice(index, 1);
}

async function onUploadDocument() {
  this.isUploading = true;
  this.isUploading = false;
  this.close();
  this.showSignerDialog = true;
}

async function onUploadDocumentOld() {
  try {
    this.isUploading = true;
    let formData = new FormData();
    formData.append("attachment", this.uploadingFiles[0]);
    formData.append("meetingid", this.meetingId);
    const res = await this.uploadMOMSignatureDocument(formData);
    if (res.status) {
      this.uploadingFiles = [];
      this.isUploading = false;
      this.close();
      this.showSignerDialog = true;
    } else {
      this.uploadingFiles = [];
      this.isUploading = false;
      this.close();
    }
  } catch (error) {
    this.isUploading = false;
  }
}
function onEmailSend(signatureType) {
  const eSignMessages = {
    Cygnature: this.$t("email.msgCygnatureSendEmailNotification"),
    Wansign: this.$t("email.msgWansignSendEmailNotification"),
  };
  const message =
    signatureType && eSignMessages[signatureType]
      ? eSignMessages[signatureType]
      : this.$t("email.msgSignerSendEmailNotification");
  this.showMessageSheet(message, "success");
}

function onSignerNext(signatureType) {
  const eSignMessages = {
    Cygnature: this.$t("email.msgCygnatureSendEmailNotification"),
    Wansign: this.$t("email.msgWansignSendEmailNotification"),
  };
  const message =
    signatureType && eSignMessages[signatureType]
      ? eSignMessages[signatureType]
      : this.$t("email.msgSignerSendEmailNotification");
  this.showMessageSheet(message, "success");
}

function onBack() {
  this.showUploadDialog = true;
}

function showMessageSheet(message, messageType) {
  this.displayMessage = true;
  this.message = message;
  this.messageType = messageType;
}

async function onStartClick() {
  this.isLoaderloading = true;
  await this.getObservers(this.meetingTypeId);
  this.isLoaderloading = false;
  this.uploadingFiles = [];
  this.showUploadDialog = true;
}
function closeStart() {
  this.uploadingFiles = [];
  this.showUploadDialog = false;
}
function close() {
  this.showUploadDialog = false;
}
</script>

<style  scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
</style>